
import './App.css';
import Navbar from './components/Navbar/Navbar';
import Router from './routes/router';
import AllRoute from "./components/Admin/AdminRoute";


function App() {
  return (
    <div className="App">

      <Router />


     
      
     

    </div>
  );
}

export default App;
